import { fetchConToken } from '../helpers/fetch';

const CartillaMiOspedycService = {
    getCartilla : (idEspecialidad, idProvincia, idLocalidad, idRubro) => {
        return fetchConToken(`MiOspedyc/Cartilla?idEspecialidad=${idEspecialidad}&idProvincia=${idProvincia}&idLocalidad=${idLocalidad}&idRubro=${idRubro}`)
    },
    getMiCartilla : () => {
        return fetchConToken(`MiOspedyc/Cartilla/MiCartilla`)
    },
    agregarFavorito : (data) => {
        return fetchConToken(`MiOspedyc/Cartilla/MiCartilla`, data, "POST")
    },
    eliminarFavorito : (idCartillaPrestadores) => {
        return fetchConToken(`MiOspedyc/Cartilla/MiCartilla/${idCartillaPrestadores}`, {}, "DELETE")
    },
}

export {CartillaMiOspedycService as default}